import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { withStyles } from '@material-ui/core/styles';
import ListItemIcon from '@material-ui/core/ListItemIcon';

const styles = theme => ({
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& $primary, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
  icon: {},
  button: {},
});
const ITEM_HEIGHT = 48;
class LongMenu extends React.Component {
  render () {
    const { classes, menuOptions, anchorEl, handleClick, handleChange, handleClose, selectedItem } = this.props;
    const open = Boolean(anchorEl);

    return (
      <div>
        <IconButton
          id={'menuButton'}
          className={classes.button}
          aria-label='More'
          aria-owns={open ? 'long-menu' : null}
          aria-haspopup='true'
          onClick={event => handleClick(event, selectedItem)}
        >
          <MoreVertIcon fontSize='default' />
        </IconButton>
        <Menu
          id='long-menu'
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 7.5,
              width: 250,
            },
          }}
        >
          {menuOptions.map(option =>
            option.visible && <MenuItem disabled={option.disabled} key={option.index} onClick={() => handleChange(option.index)}>
              <ListItemIcon className={classes.icon}>
                {option.icon}
              </ListItemIcon>
              {option.primaryText}
            </MenuItem>
          )}
        </Menu>
      </div>
    );
  }
}

export default withStyles(styles)(LongMenu);
